<template>
  <div>
    <keep-alive>
      <router-view />
    </keep-alive>
    <div class="fullwidth small-top-padding">
      <news-style-browser />
    </div>
    <div class="fullwidth darker">
      <style-browser />
    </div>
    <news-popup :newsid="$route.params.id" v-if="$route.params.id" />
  </div>
</template>

<script>
import NewsStyleBrowser from './NewsStyleBrowser.vue'
import StyleBrowser from '@/components/panels/StyleBrowser.vue'
import NewsPopup from './NewsPopup.vue'

export default {
  components: {
    NewsStyleBrowser,
    StyleBrowser,
    NewsPopup
  }

}
</script>

<style>

</style>